import { IMockHandler } from '@/mock/mock.handler.interface';
import { okDeleted, okList, okResults, okSingle } from '@/mock/mock.response.util';
import { PARAMETER_SETTING_FIXTURES, SUB_PARAMETER_SETTING_FIXTURES } from '@/mock/parameter-setting/parameter-setting.fixtures';

const ID_ROUTE = /\/parameter-setting\/([^/?]+)$/;
const SUB_PARAMETER_ID_ROUTE = /\/sub-parameter-setting\/([^/?]+)$/;

export const parameterSettingHandler: IMockHandler = {
    matches(req: any) {
        console.log('[ParameterSettingHandler.matches] Checking URL:', req.url);
        // Exclude assets/i18n files (translation files)
        if (req.url.includes('/assets/i18n/') || req.url.includes('assets/i18n/')) {
            return false;
        }

        const matches =
            req.url.includes('/parameter-setting') ||
            req.url.includes('/sub-parameter-setting');

        console.log('[ParameterSettingHandler.matches] Returning:', matches);
        return matches;
    },

    handle(req: any) {
        console.log('Request: ', req);

        const { method, url } = req;
        const idMatch = url.match(ID_ROUTE);
        const subIdMatch = url.match(SUB_PARAMETER_ID_ROUTE);

        // ── GET /parameter-setting/:id ────────────────────────────────────────
        if (method === 'GET' && idMatch) {
            const found = PARAMETER_SETTING_FIXTURES.find((u) => String(u.id) === idMatch[1]);
            return found ? okSingle(found) : okSingle(null);
        }

        // ── GET /sub-parameter-setting/:id ───────────────────────────────────
        if (method === 'GET' && subIdMatch) {
            const found = SUB_PARAMETER_SETTING_FIXTURES.find((u) => String(u.id) === subIdMatch[1]);
            return found ? okSingle(found) : okSingle(null);
        }

        // ── GET /parameter-setting ────────────────────────────────────────────
        if (method === 'GET' && url.endsWith('/parameter-setting')) {
            const page = Number(req.params.get('page') ?? 0);
            const size = Number(req.params.get('size') ?? 10);
            return okList(PARAMETER_SETTING_FIXTURES, page, size);
        }

        if (method === 'GET' && url.endsWith('/sub-parameter-setting')) {
            const page = Number(req.params.get('page') ?? 0);
            const size = Number(req.params.get('size') ?? 10);
            return okList(SUB_PARAMETER_SETTING_FIXTURES, page, size);
        }

        // ── POST /parameter-setting ───────────────────────────────────────────
        if (method === 'POST' && url.endsWith('/parameter-setting')) return okSingle({ ...req.body, id: Date.now() });

        // ── PUT /parameter-setting/:id ────────────────────────────────────────
        if (method === 'PUT' && idMatch) {
            const base = PARAMETER_SETTING_FIXTURES.find((u) => String(u.id) === idMatch[1]);
            return okSingle({ ...base, ...req.body });
        }

        // ── PUT /sub-parameter-setting/:id ───────────────────────────────────
        if (method === 'PUT' && subIdMatch) {
            const base = SUB_PARAMETER_SETTING_FIXTURES.find((u) => String(u.id) === subIdMatch[1]);
            return okSingle({ ...base, ...req.body });
        }

        // ── DELETE /parameter-setting/:id ─────────────────────────────────────
        if (method === 'DELETE' && idMatch) return okDeleted();

        // ── DELETE /sub-parameter-setting/:id ───────────────────────────────
        if (method === 'DELETE' && subIdMatch) return okDeleted();

        throw new Error(`[ParameterSettingHandler] unhandled: ${method} ${url}`);
    }
};
